import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-menu-logo',
  templateUrl: './menu-logo.component.html',
  styleUrls: ['./menu-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuLogoComponent {
  @Input() public isDarkTheme = false;
}
